"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadService = void 0;
var index_1 = require("./index");
var DownloadService = /** @class */ (function () {
    function DownloadService() {
        this.__priority = 100;
    }
    DownloadService.prototype.download = function (url, filename) {
        return setTimeout(function () {
            var link = index_1.Services.Window.document.createElement('a');
            link.download = filename == null ? '' : filename;
            link.href = url;
            index_1.Services.Window.document.body.appendChild(link);
            link.click();
            link.remove();
        }, 250);
    };
    return DownloadService;
}());
exports.DownloadService = DownloadService;
//# sourceMappingURL=download.service.js.map